import { render, staticRenderFns } from "./ToggleActiveActionTypeModal.vue?vue&type=template&id=0022b9d7&scoped=true&class=fill-height&"
import script from "./ToggleActiveActionTypeModal.vue?vue&type=script&lang=ts&"
export * from "./ToggleActiveActionTypeModal.vue?vue&type=script&lang=ts&"
import style0 from "./ToggleActiveActionTypeModal.vue?vue&type=style&index=0&id=0022b9d7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0022b9d7",
  null
  
)

export default component.exports